import React from 'react'
import { ThemeProvider, makeStyles, CssBaseline } from '@material-ui/core'
import { Route, Switch, Redirect } from 'react-router-dom'

// New login flow
import TabletRoot from './components/glueos-components/tablet-root'
import LoginPage from './components/new-login-flow/login-page'
import { GlueOSTheme, WebTheme } from './services/glue-os-theme'
import WebsiteTheme from './services/website-theme'
import CreateOrganization from './components/new-login-flow/create-organization'
import GlueButton from './components/glueos-components/glue-button'
import { logout } from './services/login'

const useStyles = makeStyles({
  root: {
    overflow: 'hidden',
    height: '100%',

    display: 'flex',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    alignItems: 'stretch'
  }
}, { name: 'MuiGlueApp' })

const App = (props) => {
  const classes = useStyles()

  const alreadyLoggedIn = !!window.localStorage.getItem('idToken')
  const ui = window.sessionStorage.getItem('ui')
  const webTheme = window.location.pathname.startsWith('/create-org') ? WebsiteTheme : WebTheme

  if (ui === 'web') {
    return (
      <ThemeProvider theme={webTheme}>
        <CssBaseline />
        <div className={classes.root}>
          <Switch>
            <Route exact path='/'>
              <Redirect to='/login' />
            </Route>
            <Route path='/login'>
              {alreadyLoggedIn ? (
                <>
                  <p>Cannot figure out frontend url 1</p>
                  <GlueButton color='destructive' onPointerDown={logout}>Log out</GlueButton>
                </>
              ) : (
                <LoginPage web />
              )}
            </Route>
            <Route path='/create-org'>
              <CreateOrganization web />
            </Route>
          </Switch>
        </div>
      </ThemeProvider>
    )
  } else if (ui === 'tablet') {
    return (
      <ThemeProvider theme={GlueOSTheme}>
        <CssBaseline />
        <div className={classes.root}>
          <TabletRoot>
            {alreadyLoggedIn ? (
              <>
                <p>Cannot figure out frontend url 2</p>
                <GlueButton color='destructive' onPointerDown={logout}>Log out</GlueButton>
              </>
            ) : (
              <Switch>
                <Route exact path='/'>
                  <Redirect to='/login' />
                </Route>
                <Route path='/login'>
                  <LoginPage />
                </Route>
                <Route path='/create-org'>
                  <CreateOrganization />
                </Route>
              </Switch>
            )}
          </TabletRoot>
        </div>
      </ThemeProvider>
    )
  }
}

export default App
